export class BadServiceRequestException extends Error implements Error {
  name = 'BadServiceRequestException';
  stack?: string;
  cause?: Error;
  message: string;
  traceParent?: string;
  responseStatus?: number;
  responseBody?: any;
  title?: string;

  constructor(message: string = 'Bad service request', traceParent?: string, responseStatus?: number, responseBody?: any, title?: string) {
    super(message);
    this.traceParent = traceParent;
    this.responseStatus = responseStatus;
    this.responseBody = responseBody;
    this.title = title;
  }
}
